// 直线

import mxcad from "mxcad";
const { McDbPoint, McDbLine, McGePoint3d, McCmColor } = mxcad;
import { MxCpp } from "mxcad";
class rlLineData {
  constructor() {
    this.McDbLine = new McDbLine();
    this.mcDbId = null;
    this.stPt = null;
    this.edPt = null;
    this.classTypeName = "rlLine";
    this.m_groupName = "rlLineGroup";
  }

  // 设置点生成直线
  setPoints(points) {
    this.points = [
      new THREE.Vector3(...points[0]),
      new THREE.Vector3(...points[1]),
    ];
  }

  draw(visible, isSetLinetype = false) {
    this.McDbLine.visible = visible;
    this.McDbLine.startPoint = new McGePoint3d(
      this.stPt.x,
      this.stPt.y,
      this.stPt.z
    );
    this.McDbLine.endPoint = new McGePoint3d(
      this.edPt.x,
      this.edPt.y,
      this.edPt.z
    );
    // this.McDbCircle.center = this.ptCenter;
    // this.McDbCircle.radius = this.Radius;
    this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.McDbLine);
    if (isSetLinetype) {
      const obj = this.mcDbId.getMcDbEntity();
      const mxcad = MxCpp.getCurrentMxCAD();
      //2000是实线,-100是空格,50是实线,-100是空格
      mxcad.addLinetype("MyAxisLineType", "2000,-100,50,-100");
      obj.linetype = "MyAxisLineType";
    }
  }
  // 删除
  erase() {
    this.mcDbId?.getMcDbEntity().erase();
  }
}

export { rlLineData };
